<template>
  <div class="popup">
    <div class="close" @click="close"><ios-close-icon /></div>
    <div class="row m-0 h-100 w-100 justify-content-center align-items-center" @click.self="close">
      <div class="col-12 col-sm-11 col-md-9 col-lg-8 col-xl-7">
        <div class="popup_inner white_bg p-3 p-md-5">
          <div class="row m-0 pb-3 mb-3 border-bottom">
            <div class="col-12 p-0">
              <h4 class="mb-0">Edit Message</h4>
            </div>
          </div>
          <div class="row m-0 mb-2 align-items-center">
            <div class="col-12 p-0">
              <b>Who do you want to receive this letter?</b>
            </div>
            <div class="col-12 p-0">
              <div class="row m-0 align-items-center">
                <div class="col p-0">
                  <select class="form-control w-100" v-model="messageToEdit.contactId" @change="selectContact">
                    <option :value="key" v-for="(contact, key) in activeContacts" :key="key">{{contact.firstname}} {{contact.lastname}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12 p-0 mt-3">
              <b>Select type of message</b>
            </div>
            <div class="col-12 p-0">
              <select class="form-control w-100" v-model="messageToEdit.type">
                <option value="heartfelt">Heartfelt messages</option>
                <option value="digital_account">Digital and social media account management</option>
                <option value="event">Event arrangements</option>
                <option value="policies">Policies and finance</option>
                <option value="legal">Legal documents</option>
                <option value="misc">Miscellaneous requests</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="col-12 p-0 mt-3">
              <b>Subject</b>
            </div>
            <div class="col-12 p-0">
              <input class="form-control" v-model="messageToEdit.subject">
            </div>
            <div class="col-12 p-0 mt-3">
              <b>Message</b>
            </div>
            <div class="col-12 p-0">
              <textarea class="form-control" v-model="messageToEdit.message" rows="5"></textarea>
            </div>
            <div class="col-12 p-0 mt-3">
              <b>Upload Attachments</b>
            </div>
            <div class="col-12 p-0">
              <div class="row m-0">
                <div class="col-12 p-0">
                <!-- <label for="upload" class="mb-0"><b>Upload pdf document</b></label> -->
                  <small id="limitHelp" class="form-text text-muted mb-1 mt-0">
                    <span v-if="theUser.subscription && theUser.subscription.details.attachments.cap && theUser.subscription.details.attachments.cap !== 'Unlimited'">
                      Your subscription allows a maximum file size of {{convertB(theUser.subscription.details.attachments.cap).amount}} {{convertB(theUser.subscription.details.attachments.cap).type}}
                    </span>
                    <span v-else>
                      Large files can take long to upload, please try limit file size to 20mb.
                    </span>
                    <div class="lh-1 mb-2">
                      <em>Please ensure the mail server is capable of receiving messages of this size.</em>
                    </div>
                  </small>
                </div>
                <div class="col-12 p-0">
                  <div class="row m-0">
                    <div class="col-auto p-0">
                      <input type="file" class="form-control border-0" id="upload" @change="onFileChange" multiple>
                      <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 p-0">
                  <small id="sizeHelp1" class="form-text error_text my-1" v-if="uploadErrors.length > 0">
                    <div>
                      {{uploadErrors.length}} file<span v-if="uploadErrors.length === 1"> was</span><span v-if="uploadErrors.length !== 1">s were</span> too big to upload or you've reached your storage cap, please upgrade your subscription
                    </div>
                    <ul>
                      <li v-for="(file, key) in uploadErrors" :key="key">
                        {{file.name}} ({{convertB(file.size).amount}} {{convertB(file.size).type}})
                      </li>
                    </ul>
                  </small>
                  <small id="sizeHelp" class="form-text text-muted my-1">{{uploads.length}} file<span v-if="uploads.length !== 1">s</span> uploaded</small>
                  <div v-for="(upload, key) in uploads" :key="key">
                    <span @click="remove(key)" class="cursor hover small">
                      <div class="row m-0 align-items-center ">
                        <div class="col-auto p-0">
                          <ios-checkmark-circle-outline-icon class="pt-1 text-success" />
                        </div>
                        <div class="col-auto mw-25 text-truncate">
                          {{upload.name}}
                        </div>
                        <div class="col-auto ps-0">
                          <small>({{convertB(upload.size).amount}} {{convertB(upload.size).type}})</small>
                        </div>
                        <div class="col-auto p-0">
                          <ios-close-circle-outline-icon class="pt-1" />
                        </div>
                        <div class="col-auto d-none d-sm-block p-0">
                          Click to remove
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 mt-4">
            <div class="col-12 p-0" v-if="messageToEdit.type && selectedContactID">
              <input type="checkbox" v-model="messageToEdit.notify"/> <b>Notify contact about message</b>
            </div>
          </div>
          <div class="row mx-0 justify-content-between align-items-end mt-4">
            <div class="col-sm-3 p-0 mb-3 mb-sm-0">
              <storage-usage :storage="temporaryTotalStorage" />
            </div>
            <div class="col-sm-8 p-0">
              <div class="row">
                <div class="col-6">
                  <button class="btn btn-secondary w-100" @click="close">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="btn btn-primary w-100" @click="save" :disabled="!selectedContactID">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/utils/firebase'
import { mapGetters, mapActions } from 'vuex'
import StorageUsage from './StorageUsage.vue'

export default {
  components: { StorageUsage },
  name: 'EditMessagePopup',
  props: ['theMessage'],
  data () {
    return {
      uploads: [],
      uploadErrors: [],
      messageToEdit: {},
      selectedContactID: null,
      isLoading: false,
      initialMessageStorage: null,
      temporaryMessageStorage: 0
    }
  },
  mounted () {
    this.messageToEdit = { ...this.theMessage }
    if (this.messageToEdit.uploads) {
      this.uploads = this.messageToEdit.uploads.slice()
    } else {
      this.uploads = []
    }
    this.setInitialMessageStorage()
    this.selectedContactID = Object.keys(this.activeContacts).find(contact => this.messageToEdit.contactId === contact)
  },
  computed: {
    ...mapGetters(['contacts', 'storageUsed', 'theUser']),
    activeContacts () {
      const obj = {}
      Object.entries(this.contacts).forEach(entry => {
        const [key, value] = entry
        if (!value.deleted) {
          obj[key] = value
        }
      })
      return obj
    },
    temporaryTotalStorage () {
      const ret = this.storageUsed - this.initialMessageStorage + this.temporaryMessageStorage
      return ret
    }
  },
  methods: {
    ...mapActions(['editMessage']),
    onFileChange (e) {
      e.target.files.forEach(item => {
        this.isLoading = true
        console.log('item', item)
        this.temporaryMessageStorage += item.size
        if (this.temporaryTotalStorage > this.theUser.subscription.details.storage) {
          this.fileTooBig(item)
          this.temporaryMessageStorage += (-item.size)
        } else {
          if (this.theUser.subscription.details.attachments.cap && (item.size > this.theUser.subscription.details.attachments.cap)) {
            this.fileTooBig(item)
            this.temporaryMessageStorage += (-item.size)
          } else {
            var file = item
            const fileName = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
            uploadFile(fileName, file, this.fileUploaded)
          }
        }
      })
    },
    fileUploaded (url, file, path, size) {
      this.uploads.push({ url: url, name: file, path: path, size: size })
      this.messageToEdit.uploads = this.uploads.slice()
      this.isLoading = false
    },
    fileTooBig (file) {
      this.uploadErrors.push(file)
      this.isLoading = false
    },
    remove (val) {
      this.uploads.splice(val, 1)
      this.messageToEdit.uploads = this.uploads.slice()
      this.setTemporaryMessageStorage()
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.editMessage(this.messageToEdit)
      this.$emit('close')
    },
    selectContact () {
      this.selectedContactID = this.messageToEdit.contactId
    },
    convertB (val) {
      var data = {
        amount: 0,
        type: null
      }
      // return Math.round(BtoGB * 100) / 100
      const BtoGB = val / 1000000000
      const BtoMB = val / 1000000
      const BtoKB = val / 1000
      if (val > 999999999) {
        data.amount = Math.round(BtoGB * 100) / 100
        data.type = 'GB'
        return data
      } else if (val > 999999) {
        data.amount = Math.round(BtoMB * 100) / 100
        data.type = 'MB'
        return data
      } else {
        data.amount = Math.round(BtoKB * 100) / 100
        data.type = 'KB'
        return data
      }
    },
    setInitialMessageStorage () {
      var messageStorage = 0
      this.uploads.forEach(file => {
        messageStorage += file.size
      })
      this.initialMessageStorage = messageStorage
      this.temporaryMessageStorage = messageStorage
    },
    setTemporaryMessageStorage () {
      var messageStorage = 0
      this.uploads.forEach(file => {
        messageStorage += file.size
      })
      this.temporaryMessageStorage = messageStorage
    }
  }
}
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.popup_inner {
  max-height: 80vh;
  overflow-y: auto;
}
.close {
  color: #fff;
  opacity: 1;
  cursor: pointer;
  position: absolute;
  right: 0;
}
input[type="file" i]::-webkit-file-upload-button {
  display: inline-flex;
}
.mw-25 {
  max-width: 25vw !important;
}
</style>
